import React, { useEffect, useState } from 'react';
import * as API from '../../framework/API/api';
import { ENTITYNAME } from '../../framework/constant/constant';
import { toast } from 'react-toastify';
import BossDialog from '../../components/BossDialog';
import { Grid, GridColumn } from '@progress/kendo-react-grid';
import moment from 'moment';

const MediaDealRightsPopup = ({ mediaDealRight_id = null, onClose }) => {
    const [grid, setGrid] = useState([]);

    useEffect(() => {
        if (mediaDealRight_id) loadData();
    }, [mediaDealRight_id]);

    const loadData = async () => {
        let res = await API.getData(ENTITYNAME.MediaDealRights, { query: ["_id", "=", mediaDealRight_id] });

        if (res.success && res?.data?.length > 0) {
            const data = res.data[0] ?? {};

            const allowedKeys = ['Name', 'FullChannelName', 'Title', 'Description', 'name'];

            const formattedData = Object.keys(data)
                .filter(key => !key.toLowerCase().includes('_id') && !key.toLowerCase().includes('sid') && key != "Platform" && key != "uniqueIdentifier")
                .map(key => {
                    let value = data[key];
                    if (typeof value === 'number' && key?.toLowerCase()?.includes('date')) {
                        value = value && value > 0 ? moment(value).utc().format('DD-MM-YYYY') : "";
                    }else if (key == "addOn") {
                        value = moment(value).utc().format('DD-MM-YYYY');
                    }
                    else if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
                        value = allowedKeys.map(k => value[k]).filter(v => v !== undefined).join(', ') ?? "";
                    }
                    else if (Array.isArray(value)) {
                        value = value.map(item => {
                            if (typeof item === 'object' && item !== null) {
                                return allowedKeys.map(k => item[k]).filter(v => v !== undefined).join(', ');
                            }
                            return item;
                        }).filter(v => v).join(', ') ?? "";
                    }
                    return { key, value };
                });
            setGrid(formattedData);
        } else {
            toast.error(res.message, { position: toast.POSITION.TOP_RIGHT });
        }
    };

    return (
        <BossDialog title="Media Deal Rights" height="520px" width="50%" onClose={onClose}>
            <Grid resizable data={grid} style={{ height: '400px' }}>
                <GridColumn field="key" title="Key" width={300} />
                <GridColumn field="value" title="Value" />
            </Grid>
        </BossDialog>
    );
};

export default MediaDealRightsPopup;
